import { Link } from "react-router-dom";
import { useLang } from "@/lib/i18n";
import KofiButton from "@/components/KofiButton";

export default function Footer() {
  const { t } = useLang();
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-black/10 dark:border-white/10 mt-10 pt-10 pb-8 px-6 md:px-10"
    >
      <div className="max-w-7xl mx-auto space-y-8">
        <div className="flex flex-col items-center gap-3">
          <KofiButton />
        </div>

        <div className="flex flex-col md:flex-row gap-4 md:gap-6 items-center justify-between border-t border-black/10 dark:border-white/10 pt-8">
          <span className="text-neutral-500 text-xs font-mono uppercase tracking-widest text-center md:text-left">
            {t("brand")} // {t("footer")}
          </span>

          <nav
            className="flex items-center gap-5 text-xs font-mono uppercase tracking-widest"
            data-testid="footer-legal-nav"
          >
            <Link
              to="/impressum"
              data-testid="footer-impressum-link"
              className="text-neutral-500 hover:text-neutral-900 dark:hover:text-white transition-colors"
            >
              {t("impressum")}
            </Link>
            <span className="text-neutral-700 dark:text-neutral-600">/</span>
            <Link
              to="/datenschutz"
              data-testid="footer-datenschutz-link"
              className="text-neutral-500 hover:text-neutral-900 dark:hover:text-white transition-colors"
            >
              {t("privacy")}
            </Link>
          </nav>

          <span className="text-neutral-500 dark:text-neutral-600 text-xs font-mono uppercase tracking-widest">
            AES-256-GCM // Zero-Knowledge
          </span>
        </div>
      </div>
    </footer>
  );
}
